import { render, staticRenderFns } from "./RequestHistory.vue?vue&type=template&id=8bc6407c"
import script from "./RequestHistory.vue?vue&type=script&lang=js"
export * from "./RequestHistory.vue?vue&type=script&lang=js"
import style0 from "./RequestHistory.vue?vue&type=style&index=0&id=8bc6407c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports